export default "__VITE_ASSET__DxvW_twa__"